export const currencies = {
  USD: { symbol: "$", rate: 1, label: "USD ($)", code: "USD" },
  GBP: { symbol: "£", rate: 0.79, label: "GBP (£)", code: "GBP" },
  AED: { symbol: "د.إ", rate: 3.67, label: "AED (د.إ)", code: "AED" },
  SAR: { symbol: "ر.س", rate: 3.75, label: "SAR (ر.س)", code: "SAR" },
  QAR: { symbol: "ر.ق", rate: 3.64, label: "QAR (ر.ق)", code: "QAR" },
}

export const defaultCurrency = "USD"
